import { A9Service, AbstractDataProviderV2, IDataProviderV2, IResourceParams } from 'components/system';
import { CustomerTypeAdd, CustomerTypeUpdate, RsCustomerType, RsCustomerTypeInfo } from './types';

export interface ICustomerTypeDataProvider extends IDataProviderV2<RsCustomerType, RsCustomerTypeInfo, CustomerTypeAdd, CustomerTypeUpdate> {
    archive(resourceParams: IResourceParams): Promise<RsCustomerTypeInfo>;

    unarchive(resourceParams: IResourceParams): Promise<RsCustomerTypeInfo>;

    setOwnership(customerType: RsCustomerTypeInfo, resourceParams: IResourceParams): Promise<RsCustomerTypeInfo>;
    releaseOwner(customerType: RsCustomerTypeInfo, resourceParams: IResourceParams): Promise<RsCustomerTypeInfo>;
}

@A9Service('customerTypeDataProvider')
class CustomerTypeDataProvider
    extends AbstractDataProviderV2<RsCustomerType, RsCustomerTypeInfo, CustomerTypeAdd, CustomerTypeUpdate>
    implements ICustomerTypeDataProvider
{
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/dict/types');
    }

    public patch(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    public archive(resourceParams: IResourceParams = {}): Promise<RsCustomerTypeInfo> {
        return this.customPatch({ active: false }, resourceParams);
    }

    public unarchive(resourceParams: IResourceParams = {}): Promise<RsCustomerTypeInfo> {
        return this.customPatch({ active: true }, resourceParams);
    }

    public setOwnership(customerType: RsCustomerTypeInfo, resourceParams: IResourceParams = {}): Promise<RsCustomerTypeInfo> {
        customerType['setOwner'] = true;
        return this.update(customerType, resourceParams);
    }

    public releaseOwner(customerType: RsCustomerTypeInfo, resourceParams: IResourceParams = {}): Promise<RsCustomerTypeInfo> {
        customerType['releaseOwner'] = true;
        return this.update(customerType, resourceParams);
    }
}
